import * as React from 'react'
import { useState, useRef, useEffect } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useFilterSelect } from './useFilterSelect'
import { useFilterSelectOverlay } from './useFilterSelectOverlay'
import Button from '@mui/material/Button'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuList from '@mui/material/MenuList'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const component = 'jobs-search'

export function FilterSelect({ placeholder, filterItems = [], isMoreFilter, filterField, filterVisibility }) {
    const { onChange, value, getFilterLabel } = useFilterSelect()
    const { handleToggle, handleClose, handleListKeyDown, anchorRef, open } = useFilterSelectOverlay()
    const [currentItem, setCurrentItem] = useState({ label: '' })
    const [isSelected, setSelected] = useState(false)

    const onSelect = (event, item) => {
        setCurrentItem(item)
        onChange(item.id, filterField)
        handleClose(event)
        if (item.id.length === 0) {
            setSelected(false)
        } else {
            setSelected(true)
        }
    }

    const handleButtonKeyDown = (event) => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            handleToggle(event)
        }
    }

    return (
        <FormControl className={`${isMoreFilter ? 'more-filter' : ''} ${filterVisibility ? filterVisibility : ''}`}>
            <InputLabel>{isSelected ? '' : placeholder}</InputLabel>

            <div>
                <Button
                    ref={anchorRef}
                    id={`selectFilterFieldButton${filterField}`}
                    aria-controls={open ? `selectFilterFieldMenu${filterField}` : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    onKeyDown={handleButtonKeyDown}
                    sx={
                        currentItem.label || currentItem.city
                            ? { justifyContent: 'space-between' }
                            : { justifyContent: 'right' }
                    }
                    endIcon={
                        open ? <ExpandLessIcon style={{ fontSize: 30 }} /> : <ExpandMoreIcon style={{ fontSize: 30 }} />
                    }
                    className={`${component}__button`}
                >
                    {getFilterLabel(currentItem, filterField)}
                </Button>
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                    className={`${component}__popper`}
                    modifiers={[{ name: 'flip', options: { fallbackPlacements: [] } }]}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                            }}
                            className={`${component}__grow`}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList
                                        autoFocusItem={open}
                                        id={`selectFilterFieldMenu${filterField}`}
                                        aria-labelledby={`selectFilterFieldButton${filterField}`}
                                        onKeyDown={handleListKeyDown}
                                        className={`${component}__list`}
                                    >
                                        <MenuItem
                                            className={`style-italic ${component}__list-item`}
                                            key={filterField}
                                            value=""
                                            onClick={(event) => onSelect(event, { id: '', label: '' })}
                                        >
                                            None
                                        </MenuItem>
                                        {filterItems.map((item) => (
                                            <MenuItem
                                                className={`${component}__list-item`}
                                                key={item.id}
                                                value={item.id}
                                                onClick={(event) => onSelect(event, item)}
                                            >
                                                {getFilterLabel(item, filterField)}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </FormControl>
    )
}
